import { Box } from "@mui/material";
import { useHasBackgroundImage } from "Hooks/Layout/useHasBackgroundImage";
import type { ReactNode } from "react";

type Props = {
  children: ReactNode;
};

/**
 * Wrapper for the stories bar. The strip fills whatever width the page gives it (the 600px
 * dashboard column on desktop, the full screen on mobile) and the bar inside scrolls
 * horizontally; whichever circle falls on the edge is cut off there, which is the only scroll
 * affordance needed. On the dark mobile hero the story names inherit a light text color from
 * here; the light desktop layout keeps the default.
 */
export const StoriesBarViewport = ({ children }: Props) => {
  const { hasBackgroundImage } = useHasBackgroundImage();

  return (
    <Box
      sx={{
        color: hasBackgroundImage ? "primary.contrastText" : undefined,
      }}
    >
      {children}
    </Box>
  );
};
